import { TrainingRecordSummaryModel } from '../defs/defs';

interface TrainingRecordStatusProps {
    record: TrainingRecordSummaryModel;
}

const TrainingRecordStatus = ({ record }: TrainingRecordStatusProps) => {
    return (
        <div className="d-flex flex-wrap justify-content-end gap-2">
            <div className="badge bg-secondary">{record.typeName}</div>

            {record.passed !== undefined && (
                <div style={{ marginTop: "-2px" }} className={`badge ${record.passed ? 'bg-success' : 'bg-danger'}`}>
                    <i className={`fas ${record.passed ? 'fa-check' : 'fa-times'}`}></i>
                    {record.passed ? ' Passed' : ' Failed'}
                </div>
            )}

            {!record.active && (
                <div style={{ marginTop: "-2px" }} className="badge bg-warning text-dark"><i className="fas fa-calendar-alt"></i> Booked</div>
            )}
        </div>
    );
};

export default TrainingRecordStatus; 